'use strict';
var global = require('../internals/global');
var classof = require('../internals/classof-raw');

module.exports = classof(global.process) === 'process';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-node.js
// module id = 121
// module chunks = 0